import React, { useContext, useState, useEffect } from 'react'
import { PublicIndexContext } from '../context/PublicIndexContext'
import { ClipLoader } from 'react-spinners'
import PowerOfAttorney from '../services/api/PowerOfAttorney'
import PropTypes from 'prop-types'
import { PowerOfAttorneySignStatus, PowerOfAttorneyStatus, PowerOfAttorneyTypes } from '../helpers/Constants.js'

const SignedPowerOfAttorney = ({ bankIDCollectResponse }) => {
  const [signedPowerOfAttorney, setSignedPowerOfAttorney] = useState(false)
  const publicIndexContext = useContext(PublicIndexContext)

  const Loader = () => {
    return <ClipLoader
      size={75}
      color={'#BF33BD'}
      loading={true}
    />
  }

  useEffect(() => {
    function getPowerOfAttorney () {
      const poa = new PowerOfAttorney()
      poa.get(publicIndexContext.siteId, PowerOfAttorneyTypes.BANKID)
        .then(response => {
          if (response.status !== 200) {
            throw new Error(response.status)
          }
          return response.json()
        })
        .then(data => {
          data.forEach(function (item) {
            if (item.statusId === PowerOfAttorneyStatus.ACTIVE && item.isSigned === PowerOfAttorneySignStatus.SIGNED) {
              setSignedPowerOfAttorney(item)
            }
          })
        })
        .catch(error => {
          console.log(error)
        })
    };
    getPowerOfAttorney()
  }, [bankIDCollectResponse])

  if (signedPowerOfAttorney) {
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-6 offset-xs-4 col-14">
            <div className="text-center mt-5">
              {publicIndexContext.formHeadingTextAfterSigning}
            </div>
            <div dangerouslySetInnerHTML={{
              __html: atob(signedPowerOfAttorney.file)
            }} className="mt-5 border p-1">
            </div>
          </div>
        </div>
      </div>
    )
  } else {
    return (
      <div className="row mt-5">
        <div className="col-12 text-center">
          <div className='sweet-loading'>
            <Loader />
          </div>
        </div>
      </div>
    )
  }
}

SignedPowerOfAttorney.propTypes = {
  bankIDCollectResponse: PropTypes.object.isRequired
}

export default SignedPowerOfAttorney
